import { css } from '@microsoft/fast-element';
import { neutralForegroundRest, getToken, foregroundOnPrimaryRest, foregroundOnSecondaryRest } from '../../design-tokens';
import { elevationRule } from '../../styles/elevation';
import { heightNumber } from '../../styles/size';
import { display } from '../../foundation/display';

export const accordionItemStyles = css`
    ${display("flex")} :host {
        box-sizing: border-box;
        flex-direction: column;
    }

    :host([color=primary]) .heading {
        background: ${getToken('color-primary-base')};
        color: ${foregroundOnPrimaryRest};
    }

    :host([color=secondary]) .heading {
        background: ${getToken('color-secondary-base')};
        color: ${foregroundOnSecondaryRest};
    }

    .region {
        display: none;
        padding: calc(${getToken('space-design-unit')} * 2px);
        font-size: ${getToken('typography-body-small-font-size')};
        line-height: ${getToken('typography-body-small-line-height')};
    }

    .heading {
        display: grid;
        grid-template-columns: auto 1fr auto calc(${heightNumber} * 1px);
        position: relative;
    }

    .button {
        box-sizing: border-box;
        appearance: none;
        border: none;
        background: none;
        grid-column: 2;
        grid-row: 1;
        outline: none;
        text-align: left;
        color: currentcolor;
        cursor: pointer;
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
        min-height: calc(${heightNumber} * 1px);
        padding: calc(${getToken('space-design-unit')} * 1px) calc(${getToken('space-design-unit')} * 2px);
    }

    .button::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        cursor: pointer;
    }

    .heading:has(.button:focus-visible) {
        outline: 2px solid currentColor;
        outline-offset: -4px;
    }

    :host([expanded]) .region {
        display: block;
    }

    .expand-collapse-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        grid-column: 4;
        pointer-events: none;
        fill: currentcolor;
        width: calc(${getToken('space-design-unit')} * 3px);
        position: relative;
    }

    slot[name="collapsed-icon"] {
        display: flex;
    }

    :host([expanded]) slot[name="collapsed-icon"] {
        display: none;
    }

    slot[name="expanded-icon"] {
        display: none;
    }

    :host([expanded]) slot[name="expanded-icon"] {
        display: flex;
    }

    .expand-collapse-icon svg {
        width: 100%;
        height: 100%;
    }

    .start {
        display: flex;
        align-items: center;
        padding-inline-start: calc(${getToken('space-design-unit')} * 1px);
        justify-content: center;
        grid-column: 1;
        position: relative;
    }

    .end {
        display: flex;
        align-items: center;
        justify-content: center;
        grid-column: 3;
        position: relative;
    }
`;
